


























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HistoryCard extends Vue {
    /**
     * Image to display.
     */
    @Prop()
    image: object;

    /**
     * Image placeholder to display.
     * This is a Base64 string.
     */
    @Prop({ default: "" })
    imagePlaceholder: string;

    /**
     * Should the image have a border (primary color)
     */
    @Prop({ default: false })
    imageBorder: boolean;

    /**
     * If the card is reversed.
     * When reversed: image on the right side
     * Otherwise: image on the left side
     */
    @Prop({ default: false })
    isReversed: boolean;
}
